import React from "react";
import { WatchLaterOutlined, CardTravel } from "@material-ui/icons";
import { getUserTravelInfo } from "../CrudAndRedux/ProfileCrud";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { actions } from "../CrudAndRedux/ProfileRedux";

const GreenCards = (props) => {
  const { state } = useSelector((state) => ({
    state: state.search,
  }));
  const [data, setData] = React.useState({});

  const { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
    if (state.user) {
      getUserTravelInfo(state.user.token)
        .then((res) => {
          dispatch(actions.getUserHistory(res.data));
        })
        .catch(() => {
          toast("مشکلی در ارتباط با سرور بوجود آمد");
        });
    }
  }, []);

  return (
    <div
      className="d-none d-md-flex justify-content-between p-0 mx my-1 text-white0 container"
      style={{ borderRadius: "13px" }}
    >
      <div
        className="col-12 col-md-4 w-50 d-flex  justify-content-between align-items-center"
        style={{
          borderRadius: 25,
          backgroundColor: "#6dd06d",
          minHeight: "12rem",
          maxWidth: "32%",
        }}
      >
        <div
          className="d-flex text-white align-items-center mx-auto"
          style={{ gap: 5 }}
        >
          <div>
            <WatchLaterOutlined style={{ fontSize: 75, color: "white" }} />
          </div>
          <div className="text-white">
            <h2 className="my-1 text-white">
              <b>
                {profileState.userHistory
                  ? Math.round(profileState.userHistory.hourCount)
                  : null}
              </b>
              ساعت
            </h2>
            <h6 className="my-1 text-white">با ایباس</h6>
          </div>
        </div>
      </div>
      <div
        className="col-12 col-md-4 w-50 d-flex  justify-content-between align-items-center"
        style={{
          borderRadius: 25,
          backgroundColor: "#6dd06d",
          minHeight: "12rem",
          maxWidth: "32%",
        }}
      >
        <div
          className="d-flex text-white align-items-center mx-auto"
          style={{ gap: 8 }}
        >
          <div>
            <i
              className="fas fa-tachometer-alt"
              style={{ fontSize: 75, color: "white" }}
            ></i>
          </div>
          <div className="text-white">
            <h2 className="my-1 text-white">
              <b>
                {" "}
                {profileState.userHistory
                  ? profileState.userHistory.distanceCount
                  : null}
              </b>{" "}
              کیلومتر
            </h2>
            <h6 className="my-1 text-white">با ایباس</h6>
          </div>
        </div>
      </div>
      <div
        className="col-12 col-md-4  d-flex  justify-content-between align-items-center"
        style={{
          borderRadius: 25,
          backgroundColor: "#6dd06d",
          minHeight: "12rem",
          maxWidth: "32%",
        }}
      >
        <div
          className="d-flex text-white align-items-center mx-auto"
          style={{ gap: 8 }}
        >
          <div>
            <CardTravel style={{ fontSize: 75, color: "white" }} />
          </div>
          <div className="text-white">
            <h2 className="my-1 text-white">
              <b>
                {" "}
                {profileState.userHistory
                  ? profileState.userHistory.travelCount
                  : null}
              </b>{" "}
              سفر
            </h2>
            <h6 className="my-1 text-white">با ایباس</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GreenCards;
